import { render, staticRenderFns } from "./BadgeLp.vue?vue&type=template&id=6cd3fc77&scoped=true&"
import script from "./BadgeLp.vue?vue&type=script&lang=js&"
export * from "./BadgeLp.vue?vue&type=script&lang=js&"
import style0 from "./BadgeLp.vue?vue&type=style&index=0&id=6cd3fc77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd3fc77",
  null
  
)

export default component.exports